<template>
  <div>
    <ag-grid-vue style='width: 100%; height: 600px;' class='ag-theme-balham-dark'
                 :gridOptions='gridOptions'
                 :enableColResize="true"
                 :showToolPanel="showToolPanel"
                 :rowData="records"
                 :enableSorting="true"
                 :suppressClickEdit="true"
                 :enableFilter="true"
                 :groupHeaders="true"
                 :suppressRowClickSelection="true"
>
    </ag-grid-vue>
  </div>
</template>
<script>
  import {AgGridVue} from 'ag-grid-vue'
  import {DefaultGridOptions} from "@/default_table_settings";
  import {applyGridPersistence} from "@/grid_persistence"

  export default {
    props: ['records', 'server'],
    data () {
      return {
        gridOptions: null,
        showToolPanel: false,
        suppressMovable: false
      }
    },
    components: {
      'ag-grid-vue': AgGridVue
    },
    methods: {
      createRowData () {
        return this.records
      },
      onGridSizeChanged () {
        this.gridOptions.api.sizeColumnsToFit()
      },
      createColumnDefs () {
        return [
          {
            headerName: 'Pokemon',
            field: 'pokemon',
            filter: 'agSetColumnFilter'
          },
          {
            headerName: 'Region',
            field: 'region',
            rowGroup: true,
            filter: 'agSetColumnFilter'
          },
          {
            headerName: 'Seen',
            field: 'seen',
            aggFunc: 'sum',
            enableValue: true,
            allowedAggFuncs: ['sum'],
            filter: 'agNumberColumnFilter'
          },
          {
            headerName: 'Caught',
            field: 'caught',
            aggFunc: 'sum',
            enableValue: true,
            allowedAggFuncs: ['sum'],
            filter: 'agNumberColumnFilter'
          },
          {
            headerName: 'Evolved',
            field: 'evolved',
            aggFunc: 'sum',
            enableValue: true,
            allowedAggFuncs: ['sum'],
            filter: 'agNumberColumnFilter'
          }
        ]
      }
    },
    beforeMount () {
      this.gridOptions = Object.assign({}, DefaultGridOptions, {
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        getContextMenuItems: this.getContextMenuItems,
        autoGroupColumnDef: {headerName: 'MonsterID',
          field: 'id',
          filter: 'agNumberColumnFilter',
          cellRenderer: 'agGroupCellRenderer',
          cellRendererParams: {
            padding: 5
          }}
      })
      applyGridPersistence(this.gridOptions, 'user-pokedex-grid')
      this.gridOptions.rowData = this.createRowData()
      this.gridOptions.columnDefs = this.createColumnDefs()
    },
    mounted () {
    }
  }
</script>

<style>
</style>
